import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { fetchOrderInfo } from '@/api/trnOrderEndpoint';
import { String } from 'lodash';

export type OrdersInfo = {
    orders: OrderState[];
    fromPage: FromPage|undefined;
};

export type OrderState = {
    orderId: number|undefined;
    isAiRecommended: boolean;
    isNewRecommended: boolean;
};

export type PayloadState = {
    orderId: number|undefined;
    isPublic: boolean;
}

export const FromPage = {
  HOME: 'home',
  SEARCH: 'search',
  WATCHLIST: 'watchlist',
  APPLIED: 'applied',
  REFUSE: 'refuse',
  CLOSED: 'closed',
} as const;

export type FromPage = typeof FromPage[keyof typeof FromPage];

const ordersInfoKey = 'ordersInfoKey';

const ordersInfoInitialState: OrdersInfo = {
        orders: [],
        fromPage: undefined
    }

const ordersModule: Module<OrdersInfo, RootState> = {
    namespaced: true,
    state: ordersInfoInitialState,
    getters: {
        getOrdersInfo(state): OrdersInfo {
            const ordersInfo = sessionStorage.getItem(ordersInfoKey);
            if (ordersInfo) {
                try {
                    const parsedInfo = JSON.parse(ordersInfo);
                    state = parsedInfo;
                } catch (e) {
                    state = ordersInfoInitialState;
                }
            }
            return state;
        }
    },
    mutations: {
        set(state, value: OrdersInfo) {
            Object.assign(state, value);
        },
        setOrdersInfo(state, orders: OrdersInfo) {
            if(state.fromPage && orders.fromPage && (state.fromPage !== orders.fromPage)) {
                state.orders = [];
            }

            const mergedOrders = [
                ...(state.orders || []),
                ...(orders.orders || []),
            ];

            const uniqueOrderIds: any[] = [];
            const uniqueOrders = [...mergedOrders].filter(order => {
                const orderId = order.orderId?.toString();
                if (uniqueOrderIds.includes(orderId)) {
                    return false;
                } else {
                    uniqueOrderIds.push(orderId);
                    return true;
                }
            });

            state.orders = uniqueOrders;
            state.fromPage = orders.fromPage ?? state.fromPage;
            sessionStorage.setItem(ordersInfoKey, JSON.stringify(state));
        }
    },
    actions: {
        async receiveOrdersInfo({ commit }, payload: PayloadState) {
            if (payload.orderId) {
                const orderInfo = await fetchOrderInfo(payload?.orderId?.toString(), true, true, Boolean(payload.isPublic), false);
                if(orderInfo?.data?.detail) {
                    const ordersInfo = {
                         orders: [
                            {
                                orderId: payload.orderId,
                                isAiRecommended: Boolean(orderInfo?.data?.detail?.trnShintyokuWithCareer?.[0]?.isAiRecommended),
                                isNewRecommended: Boolean(orderInfo?.data?.detail?.trnShintyokuWithCareer?.[0]?.isNewRecommended)
                            }
                        ]
                    }
                    commit('setOrdersInfo', ordersInfo);
                } else {
                    commit('setOrdersInfo', ordersInfoInitialState);
                }
            } else {
                commit('setOrdersInfo', ordersInfoInitialState);
            }

        }
    },
};

export default ordersModule;